export { default, getServerSideProps } from '../[id].js';